// ICCID充值系统 - 格式化工具函数

import {
  PRODUCT_STATUS_MAP,
  PRODUCT_STATUS_TAG_TYPE,
  COMMISSION_TYPE,
  COMMISSION_TYPE_MAP,
  PAYMENT_STATUS_MAP,
  PAYMENT_STATUS_TAG_TYPE,
  RECHARGE_STATUS_MAP,
  RECHARGE_STATUS_TAG_TYPE,
  ORDER_REFUND_STATUS_MAP,
  ORDER_REFUND_STATUS_TAG_TYPE,
  REFUND_STATUS_MAP,
  REFUND_STATUS_TAG_TYPE,
  APPROVE_RESULT_MAP,
  APPROVE_RESULT_TAG_TYPE
} from './iccid-constants'

// ==================== 商品/套餐状态 ====================
export function getProductStatusText(status) {
  return PRODUCT_STATUS_MAP[status] || '未知'
}

export function getProductStatusTagType(status) {
  return PRODUCT_STATUS_TAG_TYPE[status] || 'info'
}

// ==================== 分佣类型 ====================
export function getCommissionTypeText(type) {
  return COMMISSION_TYPE_MAP[type] || '未知'
}

// 格式化分佣值
export function formatCommissionValue(type, value) {
  if (type === COMMISSION_TYPE.PERCENTAGE) {
    return `${value}%`
  } else if (type === COMMISSION_TYPE.FIXED) {
    return `¥${formatMoney(value)}`
  }
  return '-'
}

// ==================== 支付状态 ====================
export function getPaymentStatusText(status) {
  return PAYMENT_STATUS_MAP[status] || '未知'
}

export function getPaymentStatusTagType(status) {
  return PAYMENT_STATUS_TAG_TYPE[status] || 'info'
}

// ==================== 充值状态 ====================
export function getRechargeStatusText(status) {
  return RECHARGE_STATUS_MAP[status] || '未知'
}

export function getRechargeStatusTagType(status) {
  return RECHARGE_STATUS_TAG_TYPE[status] || 'info'
}

// ==================== 订单退款状态 ====================
export function getOrderRefundStatusText(status) {
  return ORDER_REFUND_STATUS_MAP[status] || '未知'
}

export function getOrderRefundStatusTagType(status) {
  return ORDER_REFUND_STATUS_TAG_TYPE[status] || 'info'
}

// ==================== 退款申请状态 ====================
export function getRefundStatusText(status) {
  return REFUND_STATUS_MAP[status] || '未知'
}

export function getRefundStatusTagType(status) {
  return REFUND_STATUS_TAG_TYPE[status] || 'info'
}

// ==================== 审批结果 ====================
export function getApproveResultText(result) {
  return APPROVE_RESULT_MAP[result] || '未知'
}

export function getApproveResultTagType(result) {
  return APPROVE_RESULT_TAG_TYPE[result] || 'info'
}

// ==================== 金额格式化 ====================
export function formatMoney(amount) {
  if (amount === null || amount === undefined) {
    return '0.00'
  }
  return parseFloat(amount).toFixed(2)
}

// ==================== 日期格式化 ====================
export function formatDate(dateString) {
  if (!dateString) {
    return '-'
  }
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
